import { useCallback } from 'react';

import { useFindComponentDimensions } from '../component.hooks';
import { useFileDropperContext } from 'lib/form/file-dropper/file-dropper';
import { ACCEPT_TYPE_GIF } from 'lib/form/file-dropper/file-dropper.constants';
import { ImageCreateFieldWrapper } from '../image/image.style';
import { FileDropperImage } from 'lib/form/file-dropper/file-dropper-image';

const FILE_KEY = 'fileKey';

const GifEditUpload = ({
  id,
  onShowModal,
}: {
  id: string;
  onShowModal: (props: { key: string; fileName: string; file: File }) => void;
}) => {
  const { clearFile } = useFileDropperContext(FILE_KEY);

  const { elementDimensionLabel } = useFindComponentDimensions(id);

  const handleFileChange = useCallback(
    (key: string, fileName: string, file: File | undefined) => {
      if (file) {
        clearFile();
        onShowModal({ key, fileName, file });
      }
    },
    [clearFile, onShowModal]
  );

  return (
    <ImageCreateFieldWrapper>
      <FileDropperImage
        name={FILE_KEY}
        inputDataSelector="file-upload"
        accept={[ACCEPT_TYPE_GIF]}
        isFinishing={false}
        additionalLabel={elementDimensionLabel}
        onChange={handleFileChange}
      />
    </ImageCreateFieldWrapper>
  );
};

export default GifEditUpload;
